<script lang="ts">
  import { orgUpload } from "@nrk/origo";
  import { navigateToSearch, pageState, resetPage } from "state/page";
  import { cancelUpload, cleanupAndResetUploadState, setUploadsIdle, uploads } from "state/upload";
  import NavigationMenu from "./NavigationMenu.svelte";
  import Header from "./Header.svelte";
  import UploadButton from "./Upload/UploadButton.svelte";
  import { getAccount } from "auth/auth";
  import { first, last } from "lodash-es";
  import SearchBar from "./SearchPage/SearchBar.svelte";
  import { getCloseCallback, showCloseButton } from "../config";
  import { onMount } from "svelte";
  import { nrkClose } from "@nrk/core-icons";
  import { isPlugin } from "state/app";

  export let authenticated = true;

  $: uploadsInProgress = $uploads.state !== "IDLE";

  const account = getAccount();
  $: nameParts = account.name?.split(" ");
  $: nameInitials = nameParts?.map((part) => part.substring(0, 1));
  $: initials = `${first(nameInitials)}${
    nameInitials && nameInitials.length > 1 ? last(nameInitials) : ""
  }`;

  $: editMode = $pageState.type === "EDIT" && $pageState.editOnlyMode;
  $: uploadMode = $pageState.type === "UPLOAD";

  async function onClickTitle(event: MouseEvent) {
    if (uploadsInProgress) {
      event.preventDefault();
      if ($uploads.state !== "ALL_FAILED") {
        if (confirm("Hvis du avbryter vil opplastingene slettes")) {
          await cancelUpload();
          navigateToSearch("");
        }
      } else {
        await cleanupAndResetUploadState();
        setUploadsIdle();
        navigateToSearch("");
      }
    } else if ($pageState.type === "EDIT" && !$pageState.editOnlyMode) {
      if (confirm("Hvis du forlater redigeringssiden, vil du miste eventuelle endringer")) {
        navigateToSearch("");
      }
    } else {
      if (!editMode) {
        navigateToSearch("");
      }
    }
  }

  const cancelUploads = async (event: MouseEvent, close: boolean) => {
    event.preventDefault();
    const hasCloseCallback = getCloseCallback();
    if ($uploads.state !== "ALL_FAILED" && confirm("Hvis du avbryter vil opplastingene slettes")) {
      await cancelUpload();
      resetPage();
      if (hasCloseCallback && close) {
        hasCloseCallback();
      }
    } else if ($uploads.state === "ALL_FAILED") {
      await cleanupAndResetUploadState();
      setUploadsIdle();
      resetPage();
      if (hasCloseCallback && close) {
        hasCloseCallback();
      }
    }
  };

  const cancelCallback = async (event: MouseEvent) => {
    if (uploadMode) {
      await cancelUploads(event, true);
    } else {
      const close = getCloseCallback();
      if (close) {
        close();
      }
    }
  };

  let mounted = false;
  onMount(() => (mounted = true));
</script>

<Header {onClickTitle}>
  {#if $pageState.type !== "EDIT" && $pageState.type !== "UPLOAD" && (!isPlugin || (mounted && authenticated))}
    <SearchBar />
  {/if}
  <div class="right">
    {#if authenticated && $pageState.type !== "EDIT" && $pageState.type !== "UPLOAD"}
      <div class="upload-wrapper" class:uploading={uploadsInProgress}>
        <UploadButton>
          <span class="org-button org-button--secondary">
            {@html orgUpload}
            <span class="upload-label">{"Last opp"}</span>
          </span>
        </UploadButton>
      </div>
      {#if !isPlugin}
        <div class="user">
          <span class="org-sr">Bruker</span>
          <span class="user-badge" title={account.name}>
            {initials}
          </span>
        </div>
      {/if}
      <NavigationMenu />
    {/if}
    {#if $showCloseButton}
      <button class="org-button" on:click={cancelCallback} title="Avbryt">
        {@html nrkClose}
      </button>
    {/if}
  </div>
</Header>

<style>
  .right {
    display: flex;
  }

  .user-badge {
    cursor: default;
    width: 2rem;
    height: 2rem;
    border: 1px var(--org-color-white) solid;
    border-radius: 100%;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .user {
    font-weight: bold;
    padding: var(--org-small) var(--org-medium);
  }

  .upload-wrapper {
    display: flex;
  }

  @media (max-width: 768px) {
    .upload-label {
      display: none;
    }

    .upload-wrapper.uploading {
      display: none;
    }
  }
</style>
